// eslint-disable-next-line no-restricted-imports
import { P } from 'dripsy';

export default P;
